import React, { useState } from 'react';
import { Box, Button, makeStyles, Switch } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  editSwitchSpeed,
  editSwitchState
} from 'src/store/modules/switchButton';
import Minus from 'src/components/Icon/Minus';
import Plus from 'src/components/Icon/Plus';
import { RootState } from 'src/store';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '0 1rem 1rem 1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F5F5F5'
  },
  bottomBtn: {
    padding: '0rem 1rem 1rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: '#F5F5F5'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  }
}));

export default function SwitchAutoRolling() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [checked, setChecked] = useState(false);

  const switchSpeed = useSelector(
    (state: RootState) => state.switchButton.switchSpeed
  );

  const templateTitle = useSelector(
    (state: RootState) => state.template.templateTitle
  );

  const fillterAutoMode = templateTitle === 'AUTO SQUARE SLIDE';

  const handleChange = event => {
    setChecked(event.target.checked);
    dispatch(editSwitchState(event.target.checked));
  };

  const editSpeed = v => {
    const speed = switchSpeed + v;

    dispatch(editSwitchSpeed(speed));
  };

  if (!fillterAutoMode) return null;
  return (
    <div>
      <Box className={classes.wrapper}>
        <span
          style={{
            fontSize: '0.875rem',
            fontWeight: 600,
            fontFamily: 'Archivo',
            letterSpacing: '0.0175rem'
          }}
        >
          AUTO ROLLING
        </span>
        <Switch checked={checked} onChange={handleChange} color="primary" />
      </Box>
      {checked && (
        <div className={classes.bottomBtn}>
          <span
            style={{
              fontSize: '0.81rem',
              fontWeight: 600,
              fontFamily: 'Archivo',
              letterSpacing: '0.016rem',
              paddingBottom: '0.5rem'
            }}
          >
            SPEED (SEC)
          </span>

          <Box
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              border: '1px solid #D9D9D9',
              padding: '0.5rem'
            }}
          >
            <div style={{ display: 'flex', gap: '1rem' }}>
              <Button
                className={classes.btnMinusPlus}
                onClick={() => editSpeed(-1)}
                disabled={switchSpeed === 1}
              >
                <Minus stroke={switchSpeed === 1 ? '#BDBDBD' : '#000'} />
              </Button>
              <Button
                className={classes.btnMinusPlus}
                onClick={() => editSpeed(1)}
                disabled={switchSpeed === 3}
              >
                <Plus stroke={switchSpeed === 3 ? '#BDBDBD' : '#000'} />
              </Button>
            </div>
            <div className={classes.fontNumber}>{switchSpeed}</div>
          </Box>
        </div>
      )}
    </div>
  );
}
